import {Step3SubAction} from './Step3Actions'
import {update} from '../../../Data/ObjectHelper'
import {Step3Data, Step3State} from './Step3State'
import * as Country from '../../../Entities/Country'
import * as Nullable from '../../../Data/Nullable'
import {Company} from '../../../Entities/Company'

export function initStep3(
    company: Company,
    step3: Step3Data | null,
): Step3State {
    return {
        input: step3 !== null ?
            step3 :
            {
                invoiceName1: company.name1,
                invoiceName2: company.name2,
                invoiceName3: company.invoiceName3,
                invoiceName4: company.invoiceName4,
                invoiceStreet: company.invoiceStreet,
                invoiceHouseNumber: company.invoiceHouseNumber,
                invoiceZipCode: company.invoiceZipCode,
                invoiceCity: company.invoiceCity,
                invoiceCountry:
                    Nullable.withDefault(
                        Country.germany,
                        Country.fromCode(company.invoiceCountry)),
                vatId: company.vatId,
                deliverToInvoiceAddress: true,
                deliveryName1: company.name1,
                deliveryName2: company.name2,
                deliveryName3: company.deliveryName3,
                deliveryName4: company.deliveryName4,
                deliveryFloor: '',
                deliveryRoom: '',
                deliveryStreet: company.deliveryStreet,
                deliveryHouseNumber: company.deliveryHouseNumber,
                deliveryZipCode: company.deliveryZipCode,
                deliveryCity: company.deliveryCity,
                deliveryCountry:
                    Nullable.withDefault(
                        Country.germany,
                        Country.fromCode(company.deliveryCountry)),
                shippingMethod: 'standard',
            },
        errors: {},
    }
}

export function step3Reducer(
    state: Step3State,
    action: Step3SubAction
): Step3State {
    switch (action.type) {
        case 'InvoiceName1Changed':
            return update(
                {input: update({invoiceName1: action.value}, state.input)},
                state,
            )
        case 'InvoiceName2Changed':
            return update(
                {input: update({invoiceName2: action.value}, state.input)},
                state,
            )
        case 'InvoiceName3Changed':
            return update(
                {input: update({invoiceName3: action.value}, state.input)},
                state,
            )
        case 'InvoiceName4Changed':
            return update(
                {input: update({invoiceName4: action.value}, state.input)},
                state,
            )
        case 'InvoiceStreetChanged':
            return update(
                {input: update({invoiceStreet: action.value}, state.input)},
                state,
            )
        case 'InvoiceHouseNumberChanged':
            return update(
                {input: update({invoiceHouseNumber: action.value}, state.input)},
                state,
            )
        case 'InvoiceZipCodeChanged':
            return update(
                {input: update({invoiceZipCode: action.value}, state.input)},
                state,
            )
        case 'InvoiceCityChanged':
            return update(
                {input: update({invoiceCity: action.value}, state.input)},
                state,
            )
        case 'InvoiceCountryChanged':
            return update(
                {input: update({invoiceCountry: action.value}, state.input)},
                state,
            )
        case 'DeliverToInvoiceAddressChanged':
            return update(
                {input: update({deliverToInvoiceAddress: action.value}, state.input)},
                state,
            )
        case 'DeliveryName1Changed':
            return update(
                {input: update({deliveryName1: action.value}, state.input)},
                state,
            )
        case 'DeliveryName2Changed':
            return update(
                {input: update({deliveryName2: action.value}, state.input)},
                state,
            )
        case 'DeliveryName3Changed':
            return update(
                {input: update({deliveryName3: action.value}, state.input)},
                state,
            )
        case 'DeliveryName4Changed':
            return update(
                {input: update({deliveryName4: action.value}, state.input)},
                state,
            )
        case 'DeliveryFloorChanged':
            return update(
                {input: update({deliveryFloor: action.value}, state.input)},
                state,
            )
        case 'DeliveryRoomChanged':
            return update(
                {input: update({deliveryRoom: action.value}, state.input)},
                state,
            )
        case 'DeliveryStreetChanged':
            return update(
                {input: update({deliveryStreet: action.value}, state.input)},
                state,
            )
        case 'DeliveryHouseNumberChanged':
            return update(
                {input: update({deliveryHouseNumber: action.value}, state.input)},
                state,
            )
        case 'DeliveryZipCodeChanged':
            return update(
                {input: update({deliveryZipCode: action.value}, state.input)},
                state,
            )
        case 'DeliveryCityChanged':
            return update(
                {input: update({deliveryCity: action.value}, state.input)},
                state,
            )
        case 'DeliveryCountryChanged':
            return update(
                {input: update({deliveryCountry: action.value}, state.input)},
                state,
            )
        case 'ShippingMethodChanged':
            return update(
                {input: update({shippingMethod: action.value}, state.input)},
                state,
            )
        case 'VatIdChanged':
            return update(
                {input: update({vatId: action.value}, state.input)},
                state,
            )
    }
}

export function validateStep3(
    state: Step3State,
): Step3Data {
    const {input} = state
    return {
        invoiceName1: input.invoiceName1,
        invoiceName2: input.invoiceName2,
        invoiceName3: input.invoiceName3,
        invoiceName4: input.invoiceName4,
        invoiceStreet: input.invoiceStreet,
        invoiceHouseNumber: input.invoiceHouseNumber,
        invoiceZipCode: input.invoiceZipCode,
        invoiceCity: input.invoiceCity,
        invoiceCountry: input.invoiceCountry,
        vatId: input.vatId,
        deliverToInvoiceAddress: input.deliverToInvoiceAddress,
        deliveryName1:
            input.deliverToInvoiceAddress ?
                input.invoiceName1 :
                input.deliveryName1,
        deliveryName2:
            input.deliverToInvoiceAddress ?
                input.invoiceName2 :
                input.deliveryName2,
        deliveryName3:
            input.deliverToInvoiceAddress ?
                input.invoiceName3 :
                input.deliveryName4,
        deliveryName4:
            input.deliverToInvoiceAddress ?
                input.invoiceName4 :
                input.deliveryName4,
        deliveryFloor: input.deliveryFloor,
        deliveryRoom: input.deliveryRoom,
        deliveryStreet:
            input.deliverToInvoiceAddress ?
                input.invoiceStreet :
                input.deliveryStreet,
        deliveryHouseNumber:
            input.deliverToInvoiceAddress ?
                input.invoiceHouseNumber :
                input.deliveryHouseNumber,
        deliveryZipCode:
            input.deliverToInvoiceAddress ?
                input.invoiceZipCode :
                input.deliveryZipCode,
        deliveryCity:
            input.deliverToInvoiceAddress ?
                input.invoiceCity :
                input.deliveryCity,
        deliveryCountry:
            input.deliverToInvoiceAddress ?
                input.invoiceCountry :
                input.deliveryCountry,
        shippingMethod: input.shippingMethod,
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderCreate/Step3/Step3Reducer.ts